/* eslint-disable fp/no-mutating-methods */
// import { match } from '@nike/rcf-fp';

import {
  PERCENT_90,
  LEVEL_40,
} from '../constants';
// eslint-disable-next-line import/no-cycle
import { authUser, reAuthUser } from '../service-calls';
import NativeBridge from '../utils/native-bridge';

export default class Auth {
  static confirmAuth = async () => {
    if (!this.isAuthenticated()) {
      if (NativeBridge.isNativeApp()) {
        try {
          const token = await NativeBridge.requestAthleteToken();
          this.setNativeSession(token);
        } catch (err) {
          // Token unavailable — fall through with stale token;
          // the API call will 401 and the component error-handler decides next steps.
        }
      } else {
        await this.reAuthorize();
      }
    }
    return this.getAuth();
  };

  static getAuth = () => localStorage.getItem('accessToken');

  static getStoreId = () => localStorage.getItem('storeId');

  static isAuthenticated = () => new Date().getTime() < JSON.parse(localStorage.getItem('expiresAt'));

  static login = async (loginInformation) => {
    try {
      const auth = await authUser(loginInformation);
      if (!JSON.parse((Buffer.from(auth.access_token.split('.')[1], 'base64')).toString('utf-8')).nike_storeId) {
        // eslint-disable-next-line fp/no-throw
        throw new Error(`BERM didn't send us a store id. Try again.`); // unseen error
      }
      this.setLoginSession(auth);
      return true;
    } catch (err) {
      // eslint-disable-next-line fp/no-throw
      throw Error('Authorization Failed');
    }
  };

  /**
   * Accept a raw JWT from the native bridge, validate it contains store info,
   * persist the session, and return the decoded payload for store look-up.
   */
  static loginWithNativeToken = (accessToken) => {
    const payload = JSON.parse(
      Buffer.from(accessToken.split('.')[1], 'base64').toString('utf-8'),
    );
    if (!payload.nike_storeId) {
      // eslint-disable-next-line fp/no-throw
      throw new Error('Token does not contain store information');
    }
    this.setNativeSession(accessToken);
    return payload;
  };

  static logout = () => {
    const isNative = localStorage.getItem('isNativeApp') === 'true';
    localStorage.clear();
    if (isNative) {
      NativeBridge.requestLogout();
    }
  };

  static reAuthorize = async () => {
    try {
      const reauth = await reAuthUser(localStorage.getItem('accessToken'), localStorage.getItem('refreshToken'));
      this.setLoginSession(reauth);
      return true;
    } catch (err) {
      return false;
    }
  };

  static requiresRole = (auth, roleList) => {
    try {
      const payload = JSON.parse((Buffer.from(auth.split('.')[1], 'base64')).toString('utf-8'));
      const roles = payload.nike_storeRoles;
      if (!Array.isArray(roles)) return false;
      return !!roles.filter((role) => roleList.includes(role)).length;
    } catch {
      return false;
    }
  };

  static requiresRole40 = (auth) => Auth.requiresRole(auth, LEVEL_40);

  static setLoginSession = (auth) => {
    const expiresAt = (auth.expires_in * PERCENT_90) + new Date().getTime();
    const refreshToken = auth.refresh_token.split('.')[1];
    // Subtract 10 minutes (600,000 milliseconds) to retrieve a new refresh token if expiration is within 10 minutes
    const refreshExpiresAt = (JSON.parse(Buffer.from(refreshToken, 'base64').toString('utf-8')).exp * 1000) - 600000;
    localStorage.setItem('expiresAt', expiresAt);
    localStorage.setItem('accessToken', auth.access_token);
    localStorage.setItem('refreshToken', auth.refresh_token);
    localStorage.setItem('refreshExpiresAt', refreshExpiresAt);
  };

  /** Persist a session from a native-bridge JWT (no refresh token available). */
  static setNativeSession = (accessToken) => {
    console.log('-------------------------setNativeSession', accessToken);
    const payload = JSON.parse(
      Buffer.from(accessToken.split('.')[1], 'base64').toString('utf-8'),
    );
    const expiresAt = payload.exp
      ? (payload.exp * 1000) - 30000
      : new Date().getTime() + 3600000;
    localStorage.setItem('expiresAt', expiresAt);
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('isNativeApp', 'true');
  };

  static validRefresh = () => {
    const refreshExpires = JSON.parse(localStorage.getItem('refreshExpiresAt'));
    const currentTime = new Date().getTime();
    return currentTime < refreshExpires;
  }
}
